import React from "react";
import Rolemanagement from "../Component/Rolemanagement/Rolemanagement";

const Role = () => {
  return (
    <div>
      <Rolemanagement />
    </div>
  );
};

export default Role;
